/* Keep a product visible if its processed image service cannot respond. */
(function () {
  function originalSource(value, base) {
    try {
      const processed = new URL(value, base);
      if (processed.pathname !== '/apps/illegal-cutouts/image') return null;
      const original = new URL(processed.searchParams.get('src'));
      if (original.protocol !== 'https:') return null;
      const allowed = original.hostname === 'cdn.shopify.com'
        ? original.pathname.startsWith('/s/files/')
        : ['shopillegalshirts.com', 'www.shopillegalshirts.com', 'polandshirts.myshopify.com'].includes(original.hostname)
          && /^\/cdn\/shop\/(files|products)\//.test(original.pathname);
      return allowed ? original.href : null;
    } catch (_) { return null; }
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { originalSource };
  if (typeof document === 'undefined') return;

  function recover(image) {
    if (!image || image.tagName !== 'IMG') return;
    const original = window.StorefrontReliability?.originalSource(image.dataset.originalSrc || image.currentSrc || image.getAttribute('src'), document.baseURI);
    if (!original || image.dataset.originalAttempted === original) return;
    image.dataset.originalAttempted = original;
    // Remove the failing responsive candidates before replacing src. A failure
    // of the original image will not match the proxy path, so it cannot loop.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    void window.StorefrontReliability.swapImage(image, original, { alt: image.alt });
  }

  document.addEventListener('error', event => recover(event.target), true);
  document.querySelectorAll('img').forEach(image => {
    if (image.complete && image.naturalWidth === 0 && image.getAttribute('src')) recover(image);
    if (!image.complete && (image.dataset.originalSrc || originalSource(image.getAttribute('src'), document.baseURI))) {
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        const source = image.getAttribute('src');
        const timer = setTimeout(() => { if (image.getAttribute('src') === source && (!image.complete || !image.naturalWidth)) recover(image); }, 7000);
        image.addEventListener('load', () => clearTimeout(timer), { once: true });
      });
      observer.observe(image);
    }
  });
})();
